import { render, staticRenderFns } from "./TransferReferralModal.vue?vue&type=template&id=1da7b5c7&"
import script from "./TransferReferralModal.vue?vue&type=script&lang=ts&"
export * from "./TransferReferralModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports